import Debug from 'debug';

export enum DEBUG_NAMESPACE {
  ROOT = 'root',
  VIDEOJS = 'videojs',
  SOCIAL_LOGIN = 'social_login',
  VIEWER_ITEM = 'item',
  STORE = 'store',
  STORE_EMBED = 'store_embed',
  TRACKING = 'tracking',
  PUSHER = 'pusher',
  VIEWER_MODULE = 'viewer_module',
  INFO = 'info',
  STORE_STATS = 'store_stats',
  STORE_AI_METADATA = 'store_ai_metadata',
  STORE_ARTIFACTS = 'store_artifacts',
  STORE_TRANSCRIPTION = 'store_transcription',
  CALLBACKS_STORAGE = 'callbacks_storage',
  SMART_ACTIONS = 'store_smart_actions',
  VALIDATORS = 'validators',
}

export const useDebug = (module: DEBUG_NAMESPACE | string = DEBUG_NAMESPACE.ROOT) => {
  const debug = Debug(`viewer:${module}`);
  const isDebugEnabled = debug.enabled;

  return { debug, isDebugEnabled };
};
